import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@blueprintjs/core';

interface Props {
  disabled: boolean;
  context: {
    onActionMenuItemClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    props: {
      showActionMenuItem: boolean,
      hasPrivilegeToCreateNew: boolean;
      hasPrivilegeToDelete: boolean;
      hasPrivilegetoView: boolean;
    }
  };
}

const DialedDigitExtractionServerGridActionMenu: FunctionComponent<Props> = ({
  disabled,
  context: {
    onActionMenuItemClick,
    props: {
      showActionMenuItem,
      hasPrivilegeToCreateNew,
      hasPrivilegeToDelete,
    },
  },
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu>
      {hasPrivilegeToCreateNew && showActionMenuItem && (
        <MenuItem
          id="Restore"
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('backupRestore.grid.restore')}
        />
      )}
      {hasPrivilegeToDelete && showActionMenuItem && (
        <MenuItem
          id="Delete"
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('backupRestore.grid.delete')}
        />
      )}
    </Menu>
  );
};

export default DialedDigitExtractionServerGridActionMenu;
